jQuery(function(){
    var clickEventType = ((document.ontouchstart !== null) ? 'click' : 'touchstart');

    $(document).on('mouseenter', '.regionen-map-container [class^="region-"], .regionen-map-container [class^="city-"]', function (e) {
        if($(this).attr("class")){
            var cUid = $(this).closest(".regionen-map-container").attr("id");
            var classArray = $(this).attr("class").split(" ");

            if($("#" + cUid + " .city_circles ." + classArray[0]).length){
                moveUp( $("#" + cUid + " .city_circles ." + classArray[0]));

                setTimeout(function () {
                    $("#" + cUid + " ." + classArray[0]).addClass("active");
                }, 10);
            }
            else {
                $("#" + cUid + " ." + classArray[0]).addClass("active");
            }

            if($("#" + cUid + ".regionen-map-container .region_list li." + classArray[0] + " a").length == 0){
                $("#" + cUid + " ." + classArray[0]).css("cursor", "default");
            }
        }
    });
    $(document).on('mouseleave', '.regionen-map-container [class^="region-"], .regionen-map-container [class^="city-"]', function (e) {
        if($(this).attr("class")){
            var cUid = $(this).closest(".regionen-map-container").attr("id");
            var classArray = $(this).attr("class").split(" ");
            $("#" + cUid + '.regionen-map-container .clicked').removeClass("clicked");
            $("#" + cUid + " ." + classArray[0]).removeClass("active");
        }
    });

    $(document).on(clickEventType, '.regionen-map-container svg [class^="region-"], .regionen-map-container svg [class^="city-"]', function (e) {
        e.preventDefault();

        if($(this).attr("class")) {
            var cUid = $(this).closest(".regionen-map-container").attr("id");
            var classArray = $(this).attr("class").split(" ");

            if (window.pixelpoint.utilities.isTouchDevice()) {
                if($("#" + cUid + " ." + classArray[0]).hasClass("clicked")){
                    $("#" + cUid + ".regionen-map-container .region_list li." + classArray[0] + " a")[0].click();
                }

                $("#" + cUid + '.regionen-map-container .clicked').removeClass("clicked");
                $("#" + cUid + " ." + classArray[0]).addClass("clicked");
            }
            else{
                $("#" + cUid + ".regionen-map-container .region_list li." + classArray[0] + " a")[0].click();
            }
        }
    });
});


function moveUp(thisObject){
    //thisObject.appendTo(thisObject.parents('svg>g.city_circles'));
    thisObject.appendTo(thisObject.parent());
}